import { Card, RadioButton } from '@factorialco/deprecated-design-system'

interface Props {
  name: string
  description: string
  selected: boolean
  onClick: () => void
}

function TemplateCard({ name, description, selected, onClick }: Props) {
  return (
    <Card onClick={onClick}>
      <Card.Title
        action={<RadioButton size="medium" checked={selected} onChange={() => {}} value="" />}
      >
        {name}
      </Card.Title>
      <Card.Description>{description}</Card.Description>
    </Card>
  )
}

export default TemplateCard
